import { render } from "./MenuContentItemTableCellText.vue?vue&type=template&id=87519cd4"
import script from "./MenuContentItemTableCellText.vue?vue&type=script&lang=js"
export * from "./MenuContentItemTableCellText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__